import { addDays } from 'date-fns'
import { calculateAge } from 'util/date/calculateAge'
import { humanizeAge, humanizeAgeInWeeks } from 'util/date/humanize-age'

export const mustShowIdadeCorrigida = (idadeGestacionalInWeeks?: number, dataNascimento?: LocalDate): boolean => {
  const hasNecessaryInfo = !isNaN(idadeGestacionalInWeeks) && dataNascimento
  const isPartoATermo = idadeGestacionalInWeeks >= 37

  if (!hasNecessaryInfo || isPartoATermo) return false

  const { years: idadeCronologicaInYears } = calculateAge(dataNascimento)
  const idadeCronologicaMaximaParaExibicao = idadeGestacionalInWeeks < 28 ? 3 : 2

  return idadeCronologicaInYears < idadeCronologicaMaximaParaExibicao
}

export const calculateDataNascimentoCorrigida = (
  idadeGestacionalInWeeks: number,
  idadeGestacionalInDays: number,
  dataNascimento: LocalDate
): Date => {
  const idadeGestacionalTotalInDays = idadeGestacionalInWeeks * 7 + idadeGestacionalInDays
  const diasFaltantesParaTermo = 40 * 7 - idadeGestacionalTotalInDays

  return addDays(new Date(dataNascimento), diasFaltantesParaTermo)
}

export const getHumanizedIdadeCorrigida = (
  idadeGestacionalInWeeks?: number,
  idadeGestacionalInDays?: number,
  dataNascimento?: LocalDate
): string | null => {
  if (!mustShowIdadeCorrigida(idadeGestacionalInWeeks, dataNascimento)) return null

  const days = isNaN(idadeGestacionalInDays) ? 0 : idadeGestacionalInDays
  const dataNascimentoCorrigida = calculateDataNascimentoCorrigida(idadeGestacionalInWeeks, days, dataNascimento)

  if (dataNascimentoCorrigida > new Date(Date.now())) {
    return 'Recém-nascido'
  } else {
    const isoDataNascimento = dataNascimentoCorrigida.toISOString()
    const age = calculateAge(isoDataNascimento)

    return age.years >= 2 ? humanizeAge(isoDataNascimento) : humanizeAgeInWeeks(isoDataNascimento)
  }
}
